/**
 * @license
 * @copyright Copyright Motili Inc., 2023 All Rights Reserved
 */

import { useNavigate } from 'react-router-dom';
import YourCompany from './YourCompany';

export default function YourCompanyPage() {
    const navigate = useNavigate();
    const handleBackClick = () => navigate(-1);
    const handleNextClick = () => navigate('/client/finances');

    return (
        <YourCompany
            handleBackClick={handleBackClick}
            handleNextClick={handleNextClick}
        />
    );
}
